var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.300781C3.35826 0.300781 0 3.65904 0 7.80078C0 11.9425 3.35826 15.3008 7.5 15.3008C11.6417 15.3008 15 11.9425 15 7.80078C15 3.65904 11.6417 0.300781 7.5 0.300781ZM10.269 10.6501L9.16406 10.6451L7.5 8.66127L5.83761 10.6434L4.73103 10.6484C4.65737 10.6484 4.5971 10.5898 4.5971 10.5145C4.5971 10.4827 4.60882 10.4526 4.62891 10.4275L6.80692 7.83259L4.62891 5.2394C4.60868 5.21486 4.59745 5.18414 4.5971 5.15234C4.5971 5.07868 4.65737 5.01841 4.73103 5.01841L5.83761 5.02344L7.5 7.00725L9.16239 5.02511L10.2673 5.02009C10.341 5.02009 10.4012 5.07868 10.4012 5.15402C10.4012 5.18583 10.3895 5.21596 10.3694 5.24107L8.19475 7.83426L10.3711 10.4291C10.3912 10.4542 10.4029 10.4844 10.4029 10.5162C10.4029 10.5898 10.3426 10.6501 10.269 10.6501Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.4455abb8140582608543bd0639f756dd.svg";
export { ForwardRef as ReactComponent };